import {diContainer} from './di-container';

/**
 * Mark type as injectable. Instance of this class will be accessible to inject via `inject()` function by type
 * (constructor function).
 * @decorator
 */
export function Injectable<T extends object>(): (constructor: new (...args: any[]) => T) => void;

/**
 * Mark type as injectable. Instance of this class will be accessible to inject via `inject()` function by type
 * (constructor function) or string type alias.
 * You could specify multiple string type aliases for one Injectable.
 * You could specify one string type alias for multiple Injectables to be able to inject multiple instances at once.
 * @decorator
 */
export function Injectable<T extends object>(...aliases: string[]): (constructor: new (...args: any[]) => T) => void;

/**
 * Mark type as injectable. Instance of this class will be accessible to inject via `inject()` function by type
 * (constructor function) or string type alias.
 * You could specify multiple string type aliases for one Injectable.
 * You could specify one string type alias for multiple Injectables to be able to inject multiple instances at once.
 * @decorator
 */
export function Injectable<T extends object>(...aliases: string[]): (constructor: new (...args: any[]) => T) => void {
  return (constructor: new (...args: any[]) => T) => {
    diContainer.add(constructor, aliases);
  };
}
